var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"paper-analysis-page"},[_c('FullTxtArtAnalysisResultWorkBench',{staticStyle:{"width":"100%","height":"100%"},attrs:{"full_txt_art_analysis_data":_vm.fullTxtArtAnalysisData},on:{"clossPaperAnalysis":_vm.goHome}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }